export default {
    REWARD_ALERTS: "REWARD_ALERTS",
    REPORT_NOTIFICATIONS: "REPORT_NOTIFICATIONS",
    BATCH_EVENTS_NOTIFICATIONS: "BATCH_EVENTS_NOTIFICATIONS",
    SCHEDULED_REPORT_NOTIFICATIONS: "SCHEDULED_REPORT_NOTIFICATIONS",
};
